import _ from 'lodash'

const isLoading = (state) => _.get(state, 'loading')
const forumCategories = (state) => _.get(state, 'categories')

const chosenCategory = (state) => _.get(state, 'chosenCategory')
const forums = (state) => _.get(state, 'forums')
const forum = (state) => _.get(state, 'forum')
const pageForumCategories = (state) => _.get(state, 'pageCount.forumCategories')
const pageForums = (state) => _.get(state, 'pageCount.forums')
const comments = (state) => _.get(state, 'comments')
const isForumCommentAdding = (state) => _.get(state, 'commentAdding')
const forumBeingEdited = (state) => _.get(state, 'forumBeingEdited')
const isCommentActive = (state) => _.get(state, 'activeCommentCount', 0) > 0
const modalCategories = (state) => _.get(state, 'modalCategories')
const isLocalLoading = (state) => _.get(state, 'isLocalLoading')
const pageModalCategories = (state) => _.get(state, 'pageCount.modal')
const communityView = (state) => _.get(state, 'communityView')
const communityViewLoading = (state) => _.get(state, 'communityViewLoading')
const communityViewError = (state) => _.get(state, 'communityViewError')
const isReporting = (state) => _.get(state, 'isReporting')
const report = (state) => _.get(state, 'report')
const isLoadingReport = (state) => _.get(state, 'isLoadingReport')
const reportError = (state) => _.get(state, 'reportError')
const forumForRoute = (state) => _.get(state, 'forumForRoute')

export default {
	isLoading,
	forumCategories,
	pageForumCategories,
	pageForums,
	forums,
	forum,
	comments,
	chosenCategory,
	isForumCommentAdding,
	forumBeingEdited,
	isCommentActive,
	modalCategories,
	isLocalLoading,
	pageModalCategories,
	communityView,
	communityViewLoading,
	communityViewError,
	isReporting,
	report,
	isLoadingReport,
	reportError,
	forumForRoute,
}
